export default {
  redirect: '/redirect',
  token: '/token',
  refresh: '/refresh',
};
